module.exports = __webpack_public_path__ + "img/ic_fuzhi.2e622a02.png";